import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import FormValidation from "../../../../Common/FormValidation";
import Http from "../../../../Common/Http";
import ReactDropdown from "../../../../Common/ReactDropdown";


const EditArea = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [region, setRegion] = useState([]);
  const { id } = useParams();
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  const [selectedRegionOption, setSelectedRegionOption] = useState(null);

  // const fetchData = () => {
  //   Http.get("/area/" + id + "/edit").then((res) => {
  //     setInputs({
  //       work_place_region_id: res.data.work_place_region_id,
  //       name: res.data.name,
  //       started_from: res.data.started_from,
  //       status: res.data.status,
  //       remarks: res.data.remarks,
  //     });

  //     setSelectedRegionOption({
  //       label: res.data.region.name,
  //       value: res.data.region.id,
  //     });
  //   });

  //   Http.get("/regionSelect2").then((res) => {
  //     setRegion(res.data);
  //   });
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [res1, res2] = await Promise.all([Http.get("/area/" + id + "/edit"), Http.get("/regionSelect2")]);

      setInputs({
        work_place_region_id: parseInt(res1.data.work_place_region_id) ,
        name: res1.data.name,
        started_from: res1.data.started_from,
        status: res1.data.status,
        remarks: res1.data.remarks,
      });

      setSelectedRegionOption({
        label: res1.data.region.name,
        value: res1.data.region.id,
      });

      setRegion(res2.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const selectHandleChange = (selectedOption, actionMeta) => {
    setSelectedRegionOption({
      label: selectedOption.label,
      value: selectedOption.value,
    });

    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      Http.put("/area/" + id, inputs)
        .then((res) => {
          navigate("/area", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  const reactDropdownHandler = (field, prop) => (e) => {
    setInputs((values) => ({
      ...values,
      [field]: prop ? e.value[prop] : e.value,
    }));
  };

const findSelectedOption = (options, value, key) => {
    return options.find((item) => item[key] === value);
  };
  const status = [
    { statusName: "Active", statusValue: "active" },
    { statusName: "Inactive", statusValue: "inactive" },
  ];
  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Designation</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            {error && Object.keys(error).length > 0 && (
              <div className="row">
                <div className="col-lg">
                  <FormValidation error={error} />
                </div>
              </div>
            )}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Select Region <i className="fa fa-star required"></i>
                    </label>
                    {/* <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectedRegionOption}
                      value={selectedRegionOption}
                      onChange={selectHandleChange}
                      name="work_place_region_id"
                      options={region}
                    /> */}
                     <ReactDropdown
                      options={region}
                      optitle={"label"}
                      val={inputs.work_place_region_id}
                      onChange={reactDropdownHandler("work_place_region_id")}
                    />
                  </div>

                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold" htmlFor="">
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control select2"
                      name="started_from"
                      value={inputs.started_from || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />
                  </div>

                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold" htmlFor="">
                      Status
                    </label>
                    {/* <select className="form-control" name="status" onChange={handleChange}>
                      <option value="active" selected={inputs.status === "active" ? true : false}>
                        Active
                      </option>
                      <option value="inactive" selected={inputs.status === "inactive" ? true : false}>
                        inactive
                      </option>
                    </select> */}
                     <ReactDropdown
                      options={status}
                      optitle={"statusName"}
                      val={findSelectedOption(status, inputs.status, 'statusValue')}
                      onChange={reactDropdownHandler("status", "statusValue")}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Remarks
                    </label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      onChange={handleChange}
                      placeholder="Remarks"
                      value={inputs.remarks || ""}
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditArea;
